// @ts-nocheck
/* eslint-disable */
import Content from './content';
import { deferPromise } from "~/util/general";
import { _ } from "~/i18n";
import { store } from '~/state/store';

/**
 * @class Priorita plakatu na horni casti detailu
 * @private
 */
 export default class PlaceholderImage extends Content {
	destroy() {
		super.destroy();
		if(this._dom.uploadButton) {
			Mapy.getComponent("imageUploader").removeUploadBox(this._dom.uploadButton);
			this._dom.uploadButton = null;
		}
		this._dom = null;
	}

	getPosterData() {
		return this._promiseData.promise;
	}

	handleEvent(e) {
		if (e.currentTarget == this._dom.a) {
			e.preventDefault();
			this._placeholderClick();
		}
	}

	_build() {
		const { data } = store.getState().detail;

		this._dom.container.classList.add("placeholder-image");
		this._dom.uploadButton = Mapy.getComponent("imageUploader").getUploadBox(data);
		this._dom.uploadButton.setAttribute("data-log-source", "mapy-detail-blank");
		this._dom.uploadButton.setAttribute("data-log-action", "click");
		this._dom.uploadButton.setAttribute("data-log-text", "Přidat fotku");
		this._dom.uploadButton.setAttribute("data-log-type", data.source === "coor" ? "coor" : "poi");
		this._dom.uploadButton.setAttribute("data-log-origin", "fotky");
		this._rebuildUploadButton();

		var poster = Mapy.Util.node("div", {className: "poster"});
		var background = Mapy.Util.node("img", {src: "/img/mymap/folder-placeholder-detail.png"});
		poster.appendChild(background);
		var icon = Mapy.Util.node("div", {className: "icon"});
		icon.appendChild(Mapy.Util.node("div", {className: "message", innerHTML: _("detail.content.bestimage.message")}));
		poster.appendChild(icon);
		this._dom.uploadButton.appendChild(poster);
		this._dom.uploadButton.appendChild(icon);

		this._dom.container.appendChild(this._dom.uploadButton);

		this._promiseData = deferPromise();
		this._promiseData.resolve([this._dom.container, "placeholder"]);
	}

	_rebuildUploadButton() {
		var node = this._dom.uploadButton;
		var arr = Array.from(node.childNodes);

		for(var i = 0; i < arr.length; i++) {
			if(arr[i].nodeType == 3) {
				arr[i].remove();
			}
		}
	}

	_placeholderClick() {
		var iu = Mapy.getComponent("imageUploader");
		var coords = this._data.coords.toWGS84();

		iu.setData(this._data.source, this._data.id, {coords: [coords[0], coords[1]]});

		if (iu.isOpened()) {
			iu.close();
		}

		iu.open();
	}
}
